import { init } from "./black-box/init";

init();
